import * as jQuery from 'jquery';
import { DevicesV4Component } from '../devices-v4/devices-v4.component';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-email-devices-browsers-v4',
	templateUrl: './email-devices-browsers-v4.component.html',
	styleUrls: ['./email-devices-browsers-v4.component.css']
})
export class EmailDevicesBrowsersV4Component extends DevicesV4Component implements OnInit, AfterViewInit, OnDestroy {
	@Input() tertiarykey: string;
	@Input() datatableconfig: string;
	@Input() downloadconfig: any;
	public downloadSecondaryCSVColumns: any;
	public selectedEmailLegendName: string = 'clicks';
	public chartObjConfig = {
		addSeriesNameToLables: true,
		dataLabelsDistance: -80,
		innerSize: '0',
		lineBreak: true,
		margin: [0, 150, 0, 0],
		size: '50%',
		startAngle: 90,
		svgHeight: 0,
		svgWidth: 0,
		verticalAlign: 'middle',
		align: 'right',
		layout: 'vertical'
	};
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}
	ngOnInit(): void {
		super.ngOnInit();
		this.downloadSecondaryCSVColumns = this.downloadconfig
			? JSON.parse(decodeURI(this.downloadconfig)).downloadSecondaryCSVColumns
			: undefined;
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}
	reload(): void {
		this.chartObjConfig.svgWidth = jQuery(this.chartContainer.nativeElement).width() / 2;
		this.chartObjConfig.svgHeight = jQuery(this.chartContainer.nativeElement).height() - 80;
		this.setGraphData(this.deviceChartObjArray);
	}
	downloadCsv(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.secondarycsvQueryKey != undefined
				? this.downloadConfiguration.secondarycsvQueryKey
				: this.key,
			this.downloadConfiguration.secondaryFileName,
			this.downloadCSVColumns
		);
	}
}
